import { Divider } from "@circleco/compass/components/Divider";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

import { FileUploader } from "./FileUploader";
import { LinkUploader } from "./LinkUploader";

interface CustomPickerProps {
  dismiss: () => void;
}

export const CustomPicker = ({ dismiss }: CustomPickerProps) => (
  <div className="flex flex-col gap-4 pt-3">
    <LinkUploader close={dismiss} />
    <div className="flex items-center gap-3">
      <div className="min-w-0 flex-1">
        <Divider />
      </div>
      <Typography variant="label-sm" color="tertiary">
        {t("emoji_picker_v3.custom_icon.or")}
      </Typography>
      <div className="min-w-0 flex-1">
        <Divider />
      </div>
    </div>
    <FileUploader close={dismiss} />
  </div>
);
